import { ScheduleCommentaryCategory } from "../../../lib/enum/schedule-commentary-category.mjs"
import { ScheduleCommentaryGroupCategoryLabels } from "./schedule-commentary-group-category-labels"

const GROUP_ORDER = [
    ScheduleCommentaryCategory.CORE,
    ScheduleCommentaryCategory.SPECIALIST_SERVICES,
    ScheduleCommentaryCategory.FUNCTIONAL_SETS,
]

// Counts by catalogue group and whether the schedule is new, never by section - so moving a schedule,
// even into a custom section, doesn't change the overview.
export function buildCommentaryOverview(rows) {
    const includedRows = rows.filter((row) => !row.excludedFromCycle)
    return [
        ...buildLines(
            "update",
            includedRows.filter((row) => !isNew(row)),
            describeUpdate
        ),
        ...buildLines("new", includedRows.filter(isNew), describeNew),
    ]
}

function isNew(row) {
    return row.originalCategory === ScheduleCommentaryCategory.NEW
}

function describeUpdate(count, group) {
    return `Update of ${count} existing ${group} ${"schedule".pluralize(count)}`
}

function describeNew(count, group) {
    return `Creation of ${count} new ${group} ${"schedule".pluralize(count)}`
}

function buildLines(kind, rows, describe) {
    const countsByGroup = new Map()
    for (const row of rows) countsByGroup.set(row.groupCategory, (countsByGroup.get(row.groupCategory) ?? 0) + 1)

    const groups = [...GROUP_ORDER, ...[...countsByGroup.keys()].filter((group) => !GROUP_ORDER.includes(group))]
    return groups
        .filter((group) => countsByGroup.has(group))
        .map((group) => {
            const label = ScheduleCommentaryGroupCategoryLabels[group] ?? "Other"
            return { key: `${kind}-${group}`, text: describe(countsByGroup.get(group), label) }
        })
}
